var _defs, _filter, _rect, _circle, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvgBgP6E(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "background"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "yellow"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff5100"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "background_block",
    x: 0,
    y: 0,
    width: 200,
    height: 200,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 0,
    width: 100,
    height: 100,
    fill: "#ffd500"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 100,
    width: 100,
    height: 100,
    fill: "#ffd500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "objectBoundingBox",
    gradientTransform: "rotate(90)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#000",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#000",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "objectBoundingBox"
  }, "x\n            ", /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#000",
    stopOpacity: 0.4
  })))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "canvas"
  }, /*#__PURE__*/React.createElement("feTurbulence", {
    type: "turbulence",
    baseFrequency: "0.1 0.66",
    numOctaves: 3,
    seed: 20,
    result: "n"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "n",
    result: "noise",
    mode: "multiply"
  }), /*#__PURE__*/React.createElement("feDiffuseLighting", {
    in: "n",
    result: "light",
    lightingColor: "#ff8000"
  }, /*#__PURE__*/React.createElement("feDistantLight", {
    azimuth: 45,
    elevation: 60,
    filtername: "feDistantLight"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#ff8000",
    width: 800,
    height: 800,
    filter: "url(#canvas)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 800,
    r: 910,
    fill: "url(#background)",
    fillOpacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 800,
    height: 800,
    fill: "url(#background_block)",
    fillOpacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 0,0 0,29.253868353364744 100,29.253868353364744 100,0 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "7s",
    keyTimes: "0;0.5;1",
    values: "M 0,0 0,29.253868353364744 100,29.253868353364744 100,0 ; M 0,0 0,0 100,0 100,0 ; M 0,0 0,29.253868353364744 100,29.253868353364744 100,0 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 0,0 0,100 29.253868353364744,100 29.253868353364744,0 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "7s",
    keyTimes: "0;0.5;1",
    values: "M 0,0 0,100 29.253868353364744,100 29.253868353364744,0 ; M 0,0 0,100 0,100 0,0 ; M 0,0 0,100 29.253868353364744,100 29.253868353364744,0 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 88.2984526586541,0 100,0 100,100 88.2984526586541,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "7s",
    keyTimes: "0;0.5;1",
    values: "M 88.2984526586541,0 100,0 100,100 88.2984526586541,100 ; M 100,0 100,0 100,100 100,100 ; M 88.2984526586541,0 100,0 100,100 88.2984526586541,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 0,100 0,148.30980572855216 100,148.30980572855216 100,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "5s",
    keyTimes: "0;0.5;1",
    values: "M 0,100 0,148.30980572855216 100,148.30980572855216 100,100 ; M 0,100 0,100 100,100 100,100 ; M 0,100 0,148.30980572855216 100,148.30980572855216 100,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 0,100 0,200 48.30980572855217,200 48.30980572855217,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "5s",
    keyTimes: "0;0.5;1",
    values: "M 0,100 0,200 48.30980572855217,200 48.30980572855217,100 ; M 0,100 0,200 0,200 0,100 ; M 0,100 0,200 48.30980572855217,200 48.30980572855217,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 80.67607770857913,100 100,100 100,200 80.67607770857913,200 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "5s",
    keyTimes: "0;0.5;1",
    values: "M 80.67607770857913,100 100,100 100,200 80.67607770857913,200 ; M 100,100 100,100 100,200 100,200 ; M 80.67607770857913,100 100,100 100,200 80.67607770857913,200 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 0,200 0,235.47607308694916 100,235.47607308694916 100,200 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "12s",
    keyTimes: "0;0.5;1",
    values: "M 0,200 0,235.47607308694916 100,235.47607308694916 100,200 ; M 0,200 0,200 100,200 100,200 ; M 0,200 0,235.47607308694916 100,235.47607308694916 100,200 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 0,200 0,300 35.476073086949164,300 35.476073086949164,200 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "12s",
    keyTimes: "0;0.5;1",
    values: "M 0,200 0,300 35.476073086949164,300 35.476073086949164,200 ; M 0,200 0,300 0,300 0,200 ; M 0,200 0,300 35.476073086949164,300 35.476073086949164,200 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 85.80957076522033,200 100,200 100,300 85.80957076522033,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "12s",
    keyTimes: "0;0.5;1",
    values: "M 85.80957076522033,200 100,200 100,300 85.80957076522033,300 ; M 100,200 100,200 100,300 100,300 ; M 85.80957076522033,200 100,200 100,300 85.80957076522033,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 0,300 0,331.84139756018357 100,331.84139756018357 100,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "9s",
    keyTimes: "0;0.5;1",
    values: "M 0,300 0,331.84139756018357 100,331.84139756018357 100,300 ; M 0,300 0,300 100,300 100,300 ; M 0,300 0,331.84139756018357 100,331.84139756018357 100,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 0,300 0,400 31.84139756018358,400 31.84139756018358,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "9s",
    keyTimes: "0;0.5;1",
    values: "M 0,300 0,400 31.84139756018358,400 31.84139756018358,300 ; M 0,300 0,400 0,400 0,300 ; M 0,300 0,400 31.84139756018358,400 31.84139756018358,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 87.26344097592657,300 100,300 100,400 87.26344097592657,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "9s",
    keyTimes: "0;0.5;1",
    values: "M 87.26344097592657,300 100,300 100,400 87.26344097592657,400 ; M 100,300 100,300 100,400 100,400 ; M 87.26344097592657,300 100,300 100,400 87.26344097592657,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 0,400 0,427.10329510440516 100,427.10329510440516 100,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 0,400 0,427.10329510440516 100,427.10329510440516 100,400 ; M 0,400 0,400 100,400 100,400 ; M 0,400 0,427.10329510440516 100,427.10329510440516 100,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 0,400 0,500 27.103295104405177,500 27.103295104405177,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 0,400 0,500 27.103295104405177,500 27.103295104405177,400 ; M 0,400 0,500 0,500 0,400 ; M 0,400 0,500 27.103295104405177,500 27.103295104405177,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 89.15868195823793,400 100,400 100,500 89.15868195823793,500 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 89.15868195823793,400 100,400 100,500 89.15868195823793,500 ; M 100,400 100,400 100,500 100,500 ; M 89.15868195823793,400 100,400 100,500 89.15868195823793,500 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 0,500 0,544.9108342397918 100,544.9108342397918 100,500 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 0,500 0,544.9108342397918 100,544.9108342397918 100,500 ; M 0,500 0,500 100,500 100,500 ; M 0,500 0,544.9108342397918 100,544.9108342397918 100,500 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 0,500 0,600 44.910834239791875,600 44.910834239791875,500 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 0,500 0,600 44.910834239791875,600 44.910834239791875,500 ; M 0,500 0,600 0,600 0,500 ; M 0,500 0,600 44.910834239791875,600 44.910834239791875,500 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 82.03566630408325,500 100,500 100,600 82.03566630408325,600 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 82.03566630408325,500 100,500 100,600 82.03566630408325,600 ; M 100,500 100,500 100,600 100,600 ; M 82.03566630408325,500 100,500 100,600 82.03566630408325,600 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 0,600 0,648.3319676992878 100,648.3319676992878 100,600 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "5s",
    keyTimes: "0;0.5;1",
    values: "M 0,600 0,648.3319676992878 100,648.3319676992878 100,600 ; M 0,600 0,600 100,600 100,600 ; M 0,600 0,648.3319676992878 100,648.3319676992878 100,600 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 0,600 0,700 48.3319676992878,700 48.3319676992878,600 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "5s",
    keyTimes: "0;0.5;1",
    values: "M 0,600 0,700 48.3319676992878,700 48.3319676992878,600 ; M 0,600 0,700 0,700 0,600 ; M 0,600 0,700 48.3319676992878,700 48.3319676992878,600 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 80.66721292028488,600 100,600 100,700 80.66721292028488,700 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "5s",
    keyTimes: "0;0.5;1",
    values: "M 80.66721292028488,600 100,600 100,700 80.66721292028488,700 ; M 100,600 100,600 100,700 100,700 ; M 80.66721292028488,600 100,600 100,700 80.66721292028488,700 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 0,700 0,749.0474817050281 100,749.0474817050281 100,700 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "5s",
    keyTimes: "0;0.5;1",
    values: "M 0,700 0,749.0474817050281 100,749.0474817050281 100,700 ; M 0,700 0,700 100,700 100,700 ; M 0,700 0,749.0474817050281 100,749.0474817050281 100,700 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 0,700 0,800 49.04748170502807,800 49.04748170502807,700 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "5s",
    keyTimes: "0;0.5;1",
    values: "M 0,700 0,800 49.04748170502807,800 49.04748170502807,700 ; M 0,700 0,800 0,800 0,700 ; M 0,700 0,800 49.04748170502807,800 49.04748170502807,700 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 80.38100731798878,700 100,700 100,800 80.38100731798878,800 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "5s",
    keyTimes: "0;0.5;1",
    values: "M 80.38100731798878,700 100,700 100,800 80.38100731798878,800 ; M 100,700 100,700 100,800 100,800 ; M 80.38100731798878,700 100,700 100,800 80.38100731798878,800 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 100,0 100,47.26283177436068 200,47.26283177436068 200,0 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "15s",
    keyTimes: "0;0.5;1",
    values: "M 100,0 100,47.26283177436068 200,47.26283177436068 200,0 ; M 100,0 100,0 200,0 200,0 ; M 100,0 100,47.26283177436068 200,47.26283177436068 200,0 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 100,0 100,100 147.26283177436068,100 147.26283177436068,0 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "15s",
    keyTimes: "0;0.5;1",
    values: "M 100,0 100,100 147.26283177436068,100 147.26283177436068,0 ; M 100,0 100,100 100,100 100,0 ; M 100,0 100,100 147.26283177436068,100 147.26283177436068,0 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 181.09486729025573,0 200,0 200,100 181.09486729025573,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "15s",
    keyTimes: "0;0.5;1",
    values: "M 181.09486729025573,0 200,0 200,100 181.09486729025573,100 ; M 200,0 200,0 200,100 200,100 ; M 181.09486729025573,0 200,0 200,100 181.09486729025573,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 100,100 100,134.56989155959238 200,134.56989155959238 200,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "15s",
    keyTimes: "0;0.5;1",
    values: "M 100,100 100,134.56989155959238 200,134.56989155959238 200,100 ; M 100,100 100,100 200,100 200,100 ; M 100,100 100,134.56989155959238 200,134.56989155959238 200,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 100,100 100,200 134.56989155959238,200 134.56989155959238,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "15s",
    keyTimes: "0;0.5;1",
    values: "M 100,100 100,200 134.56989155959238,200 134.56989155959238,100 ; M 100,100 100,200 100,200 100,100 ; M 100,100 100,200 134.56989155959238,200 134.56989155959238,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 186.17204337616306,100 200,100 200,200 186.17204337616306,200 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "15s",
    keyTimes: "0;0.5;1",
    values: "M 186.17204337616306,100 200,100 200,200 186.17204337616306,200 ; M 200,100 200,100 200,200 200,200 ; M 186.17204337616306,100 200,100 200,200 186.17204337616306,200 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 100,200 100,245.07105262972058 200,245.07105262972058 200,200 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "9s",
    keyTimes: "0;0.5;1",
    values: "M 100,200 100,245.07105262972058 200,245.07105262972058 200,200 ; M 100,200 100,200 200,200 200,200 ; M 100,200 100,245.07105262972058 200,245.07105262972058 200,200 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 100,200 100,300 145.07105262972058,300 145.07105262972058,200 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "9s",
    keyTimes: "0;0.5;1",
    values: "M 100,200 100,300 145.07105262972058,300 145.07105262972058,200 ; M 100,200 100,300 100,300 100,200 ; M 100,200 100,300 145.07105262972058,300 145.07105262972058,200 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 181.97157894811176,200 200,200 200,300 181.97157894811176,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "9s",
    keyTimes: "0;0.5;1",
    values: "M 181.97157894811176,200 200,200 200,300 181.97157894811176,300 ; M 200,200 200,200 200,300 200,300 ; M 181.97157894811176,200 200,200 200,300 181.97157894811176,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 100,300 100,343.8165065894136 200,343.8165065894136 200,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 100,300 100,343.8165065894136 200,343.8165065894136 200,300 ; M 100,300 100,300 200,300 200,300 ; M 100,300 100,343.8165065894136 200,343.8165065894136 200,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 100,300 100,400 143.81650658941362,400 143.81650658941362,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 100,300 100,400 143.81650658941362,400 143.81650658941362,300 ; M 100,300 100,400 100,400 100,300 ; M 100,300 100,400 143.81650658941362,400 143.81650658941362,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 182.47339736423456,300 200,300 200,400 182.47339736423456,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 182.47339736423456,300 200,300 200,400 182.47339736423456,400 ; M 200,300 200,300 200,400 200,400 ; M 182.47339736423456,300 200,300 200,400 182.47339736423456,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 100,400 100,439.81611373843623 200,439.81611373843623 200,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 100,400 100,439.81611373843623 200,439.81611373843623 200,400 ; M 100,400 100,400 200,400 200,400 ; M 100,400 100,439.81611373843623 200,439.81611373843623 200,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 100,400 100,500 139.8161137384362,500 139.8161137384362,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 100,400 100,500 139.8161137384362,500 139.8161137384362,400 ; M 100,400 100,500 100,500 100,400 ; M 100,400 100,500 139.8161137384362,500 139.8161137384362,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 184.07355450462552,400 200,400 200,500 184.07355450462552,500 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 184.07355450462552,400 200,400 200,500 184.07355450462552,500 ; M 200,400 200,400 200,500 200,500 ; M 184.07355450462552,400 200,400 200,500 184.07355450462552,500 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 100,500 100,549.5974065026788 200,549.5974065026788 200,500 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 100,500 100,549.5974065026788 200,549.5974065026788 200,500 ; M 100,500 100,500 200,500 200,500 ; M 100,500 100,549.5974065026788 200,549.5974065026788 200,500 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 100,500 100,600 149.59740650267884,600 149.59740650267884,500 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 100,500 100,600 149.59740650267884,600 149.59740650267884,500 ; M 100,500 100,600 100,600 100,500 ; M 100,500 100,600 149.59740650267884,600 149.59740650267884,500 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 180.16103739892844,500 200,500 200,600 180.16103739892844,600 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 180.16103739892844,500 200,500 200,600 180.16103739892844,600 ; M 200,500 200,500 200,600 200,600 ; M 180.16103739892844,500 200,500 200,600 180.16103739892844,600 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 100,600 100,631.3642858159717 200,631.3642858159717 200,600 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "6s",
    keyTimes: "0;0.5;1",
    values: "M 100,600 100,631.3642858159717 200,631.3642858159717 200,600 ; M 100,600 100,600 200,600 200,600 ; M 100,600 100,631.3642858159717 200,631.3642858159717 200,600 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 100,600 100,700 131.3642858159717,700 131.3642858159717,600 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "6s",
    keyTimes: "0;0.5;1",
    values: "M 100,600 100,700 131.3642858159717,700 131.3642858159717,600 ; M 100,600 100,700 100,700 100,600 ; M 100,600 100,700 131.3642858159717,700 131.3642858159717,600 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 187.45428567361134,600 200,600 200,700 187.45428567361134,700 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "6s",
    keyTimes: "0;0.5;1",
    values: "M 187.45428567361134,600 200,600 200,700 187.45428567361134,700 ; M 200,600 200,600 200,700 200,700 ; M 187.45428567361134,600 200,600 200,700 187.45428567361134,700 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 100,700 100,740.049084639685 200,740.049084639685 200,700 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "9s",
    keyTimes: "0;0.5;1",
    values: "M 100,700 100,740.049084639685 200,740.049084639685 200,700 ; M 100,700 100,700 200,700 200,700 ; M 100,700 100,740.049084639685 200,740.049084639685 200,700 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 100,700 100,800 140.049084639685,800 140.049084639685,700 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "9s",
    keyTimes: "0;0.5;1",
    values: "M 100,700 100,800 140.049084639685,800 140.049084639685,700 ; M 100,700 100,800 100,800 100,700 ; M 100,700 100,800 140.049084639685,800 140.049084639685,700 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 183.980366144126,700 200,700 200,800 183.980366144126,800 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "9s",
    keyTimes: "0;0.5;1",
    values: "M 183.980366144126,700 200,700 200,800 183.980366144126,800 ; M 200,700 200,700 200,800 200,800 ; M 183.980366144126,700 200,700 200,800 183.980366144126,800 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 200,0 200,43.268017881798635 300,43.268017881798635 300,0 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "9s",
    keyTimes: "0;0.5;1",
    values: "M 200,0 200,43.268017881798635 300,43.268017881798635 300,0 ; M 200,0 200,0 300,0 300,0 ; M 200,0 200,43.268017881798635 300,43.268017881798635 300,0 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 200,0 200,100 243.26801788179864,100 243.26801788179864,0 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "9s",
    keyTimes: "0;0.5;1",
    values: "M 200,0 200,100 243.26801788179864,100 243.26801788179864,0 ; M 200,0 200,100 200,100 200,0 ; M 200,0 200,100 243.26801788179864,100 243.26801788179864,0 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 282.69279284728054,0 300,0 300,100 282.69279284728054,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "9s",
    keyTimes: "0;0.5;1",
    values: "M 282.69279284728054,0 300,0 300,100 282.69279284728054,100 ; M 300,0 300,0 300,100 300,100 ; M 282.69279284728054,0 300,0 300,100 282.69279284728054,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 200,100 200,132.81133195487618 300,132.81133195487618 300,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 200,100 200,132.81133195487618 300,132.81133195487618 300,100 ; M 200,100 200,100 300,100 300,100 ; M 200,100 200,132.81133195487618 300,132.81133195487618 300,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 200,100 200,200 232.81133195487618,200 232.81133195487618,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 200,100 200,200 232.81133195487618,200 232.81133195487618,100 ; M 200,100 200,200 200,200 200,100 ; M 200,100 200,200 232.81133195487618,200 232.81133195487618,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 286.87546721804955,100 300,100 300,200 286.87546721804955,200 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 286.87546721804955,100 300,100 300,200 286.87546721804955,200 ; M 300,100 300,100 300,200 300,200 ; M 286.87546721804955,100 300,100 300,200 286.87546721804955,200 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 200,200 200,246.1360659514016 300,246.1360659514016 300,200 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "14s",
    keyTimes: "0;0.5;1",
    values: "M 200,200 200,246.1360659514016 300,246.1360659514016 300,200 ; M 200,200 200,200 300,200 300,200 ; M 200,200 200,246.1360659514016 300,246.1360659514016 300,200 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 200,200 200,300 246.1360659514016,300 246.1360659514016,200 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "14s",
    keyTimes: "0;0.5;1",
    values: "M 200,200 200,300 246.1360659514016,300 246.1360659514016,200 ; M 200,200 200,300 200,300 200,200 ; M 200,200 200,300 246.1360659514016,300 246.1360659514016,200 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 281.5455736194394,200 300,200 300,300 281.5455736194394,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "14s",
    keyTimes: "0;0.5;1",
    values: "M 281.5455736194394,200 300,200 300,300 281.5455736194394,300 ; M 300,200 300,200 300,300 300,300 ; M 281.5455736194394,200 300,200 300,300 281.5455736194394,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 200,300 200,342.3013125582162 300,342.3013125582162 300,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "12s",
    keyTimes: "0;0.5;1",
    values: "M 200,300 200,342.3013125582162 300,342.3013125582162 300,300 ; M 200,300 200,300 300,300 300,300 ; M 200,300 200,342.3013125582162 300,342.3013125582162 300,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 200,300 200,400 242.30131255821618,400 242.30131255821618,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "12s",
    keyTimes: "0;0.5;1",
    values: "M 200,300 200,400 242.30131255821618,400 242.30131255821618,300 ; M 200,300 200,400 200,400 200,300 ; M 200,300 200,400 242.30131255821618,400 242.30131255821618,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 283.0794749767135,300 300,300 300,400 283.0794749767135,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "12s",
    keyTimes: "0;0.5;1",
    values: "M 283.0794749767135,300 300,300 300,400 283.0794749767135,400 ; M 300,300 300,300 300,400 300,400 ; M 283.0794749767135,300 300,300 300,400 283.0794749767135,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 200,400 200,428.1569673825776 300,428.1569673825776 300,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "14s",
    keyTimes: "0;0.5;1",
    values: "M 200,400 200,428.1569673825776 300,428.1569673825776 300,400 ; M 200,400 200,400 300,400 300,400 ; M 200,400 200,428.1569673825776 300,428.1569673825776 300,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 200,400 200,500 228.1569673825776,500 228.1569673825776,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "14s",
    keyTimes: "0;0.5;1",
    values: "M 200,400 200,500 228.1569673825776,500 228.1569673825776,400 ; M 200,400 200,500 200,500 200,400 ; M 200,400 200,500 228.1569673825776,500 228.1569673825776,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 288.737213046969,400 300,400 300,500 288.737213046969,500 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "14s",
    keyTimes: "0;0.5;1",
    values: "M 288.737213046969,400 300,400 300,500 288.737213046969,500 ; M 300,400 300,400 300,500 300,500 ; M 288.737213046969,400 300,400 300,500 288.737213046969,500 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 200,500 200,532.0888012053448 300,532.0888012053448 300,500 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "10s",
    keyTimes: "0;0.5;1",
    values: "M 200,500 200,532.0888012053448 300,532.0888012053448 300,500 ; M 200,500 200,500 300,500 300,500 ; M 200,500 200,532.0888012053448 300,532.0888012053448 300,500 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 200,500 200,600 232.08880120534477,600 232.08880120534477,500 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "10s",
    keyTimes: "0;0.5;1",
    values: "M 200,500 200,600 232.08880120534477,600 232.08880120534477,500 ; M 200,500 200,600 200,600 200,500 ; M 200,500 200,600 232.08880120534477,600 232.08880120534477,500 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 287.1644795178621,500 300,500 300,600 287.1644795178621,600 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "10s",
    keyTimes: "0;0.5;1",
    values: "M 287.1644795178621,500 300,500 300,600 287.1644795178621,600 ; M 300,500 300,500 300,600 300,600 ; M 287.1644795178621,500 300,500 300,600 287.1644795178621,600 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 200,600 200,647.5792359806062 300,647.5792359806062 300,600 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "9s",
    keyTimes: "0;0.5;1",
    values: "M 200,600 200,647.5792359806062 300,647.5792359806062 300,600 ; M 200,600 200,600 300,600 300,600 ; M 200,600 200,647.5792359806062 300,647.5792359806062 300,600 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 200,600 200,700 247.5792359806062,700 247.5792359806062,600 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "9s",
    keyTimes: "0;0.5;1",
    values: "M 200,600 200,700 247.5792359806062,700 247.5792359806062,600 ; M 200,600 200,700 200,700 200,600 ; M 200,600 200,700 247.5792359806062,700 247.5792359806062,600 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 280.96830560775754,600 300,600 300,700 280.96830560775754,700 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "9s",
    keyTimes: "0;0.5;1",
    values: "M 280.96830560775754,600 300,600 300,700 280.96830560775754,700 ; M 300,600 300,600 300,700 300,700 ; M 280.96830560775754,600 300,600 300,700 280.96830560775754,700 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 200,700 200,746.1555785957396 300,746.1555785957396 300,700 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 200,700 200,746.1555785957396 300,746.1555785957396 300,700 ; M 200,700 200,700 300,700 300,700 ; M 200,700 200,746.1555785957396 300,746.1555785957396 300,700 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 200,700 200,800 246.15557859573957,800 246.15557859573957,700 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 200,700 200,800 246.15557859573957,800 246.15557859573957,700 ; M 200,700 200,800 200,800 200,700 ; M 200,700 200,800 246.15557859573957,800 246.15557859573957,700 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 281.5377685617042,700 300,700 300,800 281.5377685617042,800 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 281.5377685617042,700 300,700 300,800 281.5377685617042,800 ; M 300,700 300,700 300,800 300,800 ; M 281.5377685617042,700 300,700 300,800 281.5377685617042,800 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 300,0 300,37.70969746395926 400,37.70969746395926 400,0 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "10s",
    keyTimes: "0;0.5;1",
    values: "M 300,0 300,37.70969746395926 400,37.70969746395926 400,0 ; M 300,0 300,0 400,0 400,0 ; M 300,0 300,37.70969746395926 400,37.70969746395926 400,0 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 300,0 300,100 337.7096974639593,100 337.7096974639593,0 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "10s",
    keyTimes: "0;0.5;1",
    values: "M 300,0 300,100 337.7096974639593,100 337.7096974639593,0 ; M 300,0 300,100 300,100 300,0 ; M 300,0 300,100 337.7096974639593,100 337.7096974639593,0 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 384.9161210144163,0 400,0 400,100 384.9161210144163,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "10s",
    keyTimes: "0;0.5;1",
    values: "M 384.9161210144163,0 400,0 400,100 384.9161210144163,100 ; M 400,0 400,0 400,100 400,100 ; M 384.9161210144163,0 400,0 400,100 384.9161210144163,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 300,100 300,149.14598874214164 400,149.14598874214164 400,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "15s",
    keyTimes: "0;0.5;1",
    values: "M 300,100 300,149.14598874214164 400,149.14598874214164 400,100 ; M 300,100 300,100 400,100 400,100 ; M 300,100 300,149.14598874214164 400,149.14598874214164 400,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 300,100 300,200 349.14598874214164,200 349.14598874214164,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "15s",
    keyTimes: "0;0.5;1",
    values: "M 300,100 300,200 349.14598874214164,200 349.14598874214164,100 ; M 300,100 300,200 300,200 300,100 ; M 300,100 300,200 349.14598874214164,200 349.14598874214164,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 380.34160450314334,100 400,100 400,200 380.34160450314334,200 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "15s",
    keyTimes: "0;0.5;1",
    values: "M 380.34160450314334,100 400,100 400,200 380.34160450314334,200 ; M 400,100 400,100 400,200 400,200 ; M 380.34160450314334,100 400,100 400,200 380.34160450314334,200 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 300,200 300,229.4777334843731 400,229.4777334843731 400,200 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 300,200 300,229.4777334843731 400,229.4777334843731 400,200 ; M 300,200 300,200 400,200 400,200 ; M 300,200 300,229.4777334843731 400,229.4777334843731 400,200 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 300,200 300,300 329.4777334843731,300 329.4777334843731,200 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 300,200 300,300 329.4777334843731,300 329.4777334843731,200 ; M 300,200 300,300 300,300 300,200 ; M 300,200 300,300 329.4777334843731,300 329.4777334843731,200 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 388.20890660625076,200 400,200 400,300 388.20890660625076,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 388.20890660625076,200 400,200 400,300 388.20890660625076,300 ; M 400,200 400,200 400,300 400,300 ; M 388.20890660625076,200 400,200 400,300 388.20890660625076,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 300,300 300,331.2988855891995 400,331.2988855891995 400,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "14s",
    keyTimes: "0;0.5;1",
    values: "M 300,300 300,331.2988855891995 400,331.2988855891995 400,300 ; M 300,300 300,300 400,300 400,300 ; M 300,300 300,331.2988855891995 400,331.2988855891995 400,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 300,300 300,400 331.2988855891995,400 331.2988855891995,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "14s",
    keyTimes: "0;0.5;1",
    values: "M 300,300 300,400 331.2988855891995,400 331.2988855891995,300 ; M 300,300 300,400 300,400 300,300 ; M 300,300 300,400 331.2988855891995,400 331.2988855891995,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 387.4804457643202,300 400,300 400,400 387.4804457643202,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "14s",
    keyTimes: "0;0.5;1",
    values: "M 387.4804457643202,300 400,300 400,400 387.4804457643202,400 ; M 400,300 400,300 400,400 400,400 ; M 387.4804457643202,300 400,300 400,400 387.4804457643202,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 300,400 300,436.6001846196264 400,436.6001846196264 400,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "10s",
    keyTimes: "0;0.5;1",
    values: "M 300,400 300,436.6001846196264 400,436.6001846196264 400,400 ; M 300,400 300,400 400,400 400,400 ; M 300,400 300,436.6001846196264 400,436.6001846196264 400,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 300,400 300,500 336.6001846196264,500 336.6001846196264,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "10s",
    keyTimes: "0;0.5;1",
    values: "M 300,400 300,500 336.6001846196264,500 336.6001846196264,400 ; M 300,400 300,500 300,500 300,400 ; M 300,400 300,500 336.6001846196264,500 336.6001846196264,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 385.3599261521494,400 400,400 400,500 385.3599261521494,500 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "10s",
    keyTimes: "0;0.5;1",
    values: "M 385.3599261521494,400 400,400 400,500 385.3599261521494,500 ; M 400,400 400,400 400,500 400,500 ; M 385.3599261521494,400 400,400 400,500 385.3599261521494,500 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 300,500 300,533.8801922098938 400,533.8801922098938 400,500 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "14s",
    keyTimes: "0;0.5;1",
    values: "M 300,500 300,533.8801922098938 400,533.8801922098938 400,500 ; M 300,500 300,500 400,500 400,500 ; M 300,500 300,533.8801922098938 400,533.8801922098938 400,500 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 300,500 300,600 333.8801922098938,600 333.8801922098938,500 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "14s",
    keyTimes: "0;0.5;1",
    values: "M 300,500 300,600 333.8801922098938,600 333.8801922098938,500 ; M 300,500 300,600 300,600 300,500 ; M 300,500 300,600 333.8801922098938,600 333.8801922098938,500 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 386.4479231160425,500 400,500 400,600 386.4479231160425,600 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "14s",
    keyTimes: "0;0.5;1",
    values: "M 386.4479231160425,500 400,500 400,600 386.4479231160425,600 ; M 400,500 400,500 400,600 400,600 ; M 386.4479231160425,500 400,500 400,600 386.4479231160425,600 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 300,600 300,633.0724957306511 400,633.0724957306511 400,600 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "8s",
    keyTimes: "0;0.5;1",
    values: "M 300,600 300,633.0724957306511 400,633.0724957306511 400,600 ; M 300,600 300,600 400,600 400,600 ; M 300,600 300,633.0724957306511 400,633.0724957306511 400,600 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 300,600 300,700 333.0724957306511,700 333.0724957306511,600 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "8s",
    keyTimes: "0;0.5;1",
    values: "M 300,600 300,700 333.0724957306511,700 333.0724957306511,600 ; M 300,600 300,700 300,700 300,600 ; M 300,600 300,700 333.0724957306511,700 333.0724957306511,600 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 386.7710017077396,600 400,600 400,700 386.7710017077396,700 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "8s",
    keyTimes: "0;0.5;1",
    values: "M 386.7710017077396,600 400,600 400,700 386.7710017077396,700 ; M 400,600 400,600 400,700 400,700 ; M 386.7710017077396,600 400,600 400,700 386.7710017077396,700 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 300,700 300,747.8849320309935 400,747.8849320309935 400,700 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 300,700 300,747.8849320309935 400,747.8849320309935 400,700 ; M 300,700 300,700 400,700 400,700 ; M 300,700 300,747.8849320309935 400,747.8849320309935 400,700 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 300,700 300,800 347.88493203099347,800 347.88493203099347,700 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 300,700 300,800 347.88493203099347,800 347.88493203099347,700 ; M 300,700 300,800 300,800 300,700 ; M 300,700 300,800 347.88493203099347,800 347.88493203099347,700 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 380.8460271876026,700 400,700 400,800 380.8460271876026,800 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 380.8460271876026,700 400,700 400,800 380.8460271876026,800 ; M 400,700 400,700 400,800 400,800 ; M 380.8460271876026,700 400,700 400,800 380.8460271876026,800 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 400,0 400,39.33945333756051 500,39.33945333756051 500,0 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "12s",
    keyTimes: "0;0.5;1",
    values: "M 400,0 400,39.33945333756051 500,39.33945333756051 500,0 ; M 400,0 400,0 500,0 500,0 ; M 400,0 400,39.33945333756051 500,39.33945333756051 500,0 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 400,0 400,100 439.3394533375605,100 439.3394533375605,0 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "12s",
    keyTimes: "0;0.5;1",
    values: "M 400,0 400,100 439.3394533375605,100 439.3394533375605,0 ; M 400,0 400,100 400,100 400,0 ; M 400,0 400,100 439.3394533375605,100 439.3394533375605,0 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 484.2642186649758,0 500,0 500,100 484.2642186649758,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "12s",
    keyTimes: "0;0.5;1",
    values: "M 484.2642186649758,0 500,0 500,100 484.2642186649758,100 ; M 500,0 500,0 500,100 500,100 ; M 484.2642186649758,0 500,0 500,100 484.2642186649758,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 400,100 400,127.90804797773086 500,127.90804797773086 500,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "5s",
    keyTimes: "0;0.5;1",
    values: "M 400,100 400,127.90804797773086 500,127.90804797773086 500,100 ; M 400,100 400,100 500,100 500,100 ; M 400,100 400,127.90804797773086 500,127.90804797773086 500,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 400,100 400,200 427.90804797773086,200 427.90804797773086,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "5s",
    keyTimes: "0;0.5;1",
    values: "M 400,100 400,200 427.90804797773086,200 427.90804797773086,100 ; M 400,100 400,200 400,200 400,100 ; M 400,100 400,200 427.90804797773086,200 427.90804797773086,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 488.83678080890763,100 500,100 500,200 488.83678080890763,200 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "5s",
    keyTimes: "0;0.5;1",
    values: "M 488.83678080890763,100 500,100 500,200 488.83678080890763,200 ; M 500,100 500,100 500,200 500,200 ; M 488.83678080890763,100 500,100 500,200 488.83678080890763,200 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 400,200 400,238.85442101517935 500,238.85442101517935 500,200 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "12s",
    keyTimes: "0;0.5;1",
    values: "M 400,200 400,238.85442101517935 500,238.85442101517935 500,200 ; M 400,200 400,200 500,200 500,200 ; M 400,200 400,238.85442101517935 500,238.85442101517935 500,200 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 400,200 400,300 438.85442101517935,300 438.85442101517935,200 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "12s",
    keyTimes: "0;0.5;1",
    values: "M 400,200 400,300 438.85442101517935,300 438.85442101517935,200 ; M 400,200 400,300 400,300 400,200 ; M 400,200 400,300 438.85442101517935,300 438.85442101517935,200 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 484.45823159392825,200 500,200 500,300 484.45823159392825,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "12s",
    keyTimes: "0;0.5;1",
    values: "M 484.45823159392825,200 500,200 500,300 484.45823159392825,300 ; M 500,200 500,200 500,300 500,300 ; M 484.45823159392825,200 500,200 500,300 484.45823159392825,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 400,300 400,336.3011456512986 500,336.3011456512986 500,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "6s",
    keyTimes: "0;0.5;1",
    values: "M 400,300 400,336.3011456512986 500,336.3011456512986 500,300 ; M 400,300 400,300 500,300 500,300 ; M 400,300 400,336.3011456512986 500,336.3011456512986 500,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 400,300 400,400 436.3011456512986,400 436.3011456512986,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "6s",
    keyTimes: "0;0.5;1",
    values: "M 400,300 400,400 436.3011456512986,400 436.3011456512986,300 ; M 400,300 400,400 400,400 400,300 ; M 400,300 400,400 436.3011456512986,400 436.3011456512986,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 485.47954173948057,300 500,300 500,400 485.47954173948057,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "6s",
    keyTimes: "0;0.5;1",
    values: "M 485.47954173948057,300 500,300 500,400 485.47954173948057,400 ; M 500,300 500,300 500,400 500,400 ; M 485.47954173948057,300 500,300 500,400 485.47954173948057,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 400,400 400,442.9134957434525 500,442.9134957434525 500,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 400,400 400,442.9134957434525 500,442.9134957434525 500,400 ; M 400,400 400,400 500,400 500,400 ; M 400,400 400,442.9134957434525 500,442.9134957434525 500,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 400,400 400,500 442.9134957434525,500 442.9134957434525,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 400,400 400,500 442.9134957434525,500 442.9134957434525,400 ; M 400,400 400,500 400,500 400,400 ; M 400,400 400,500 442.9134957434525,500 442.9134957434525,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 482.834601702619,400 500,400 500,500 482.834601702619,500 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 482.834601702619,400 500,400 500,500 482.834601702619,500 ; M 500,400 500,400 500,500 500,500 ; M 482.834601702619,400 500,400 500,500 482.834601702619,500 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 400,500 400,532.6893706151483 500,532.6893706151483 500,500 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 400,500 400,532.6893706151483 500,532.6893706151483 500,500 ; M 400,500 400,500 500,500 500,500 ; M 400,500 400,532.6893706151483 500,532.6893706151483 500,500 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 400,500 400,600 432.6893706151483,600 432.6893706151483,500 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 400,500 400,600 432.6893706151483,600 432.6893706151483,500 ; M 400,500 400,600 400,600 400,500 ; M 400,500 400,600 432.6893706151483,600 432.6893706151483,500 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 486.92425175394067,500 500,500 500,600 486.92425175394067,600 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 486.92425175394067,500 500,500 500,600 486.92425175394067,600 ; M 500,500 500,500 500,600 500,600 ; M 486.92425175394067,500 500,500 500,600 486.92425175394067,600 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 400,600 400,640.6955893415304 500,640.6955893415304 500,600 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "15s",
    keyTimes: "0;0.5;1",
    values: "M 400,600 400,640.6955893415304 500,640.6955893415304 500,600 ; M 400,600 400,600 500,600 500,600 ; M 400,600 400,640.6955893415304 500,640.6955893415304 500,600 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 400,600 400,700 440.6955893415304,700 440.6955893415304,600 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "15s",
    keyTimes: "0;0.5;1",
    values: "M 400,600 400,700 440.6955893415304,700 440.6955893415304,600 ; M 400,600 400,700 400,700 400,600 ; M 400,600 400,700 440.6955893415304,700 440.6955893415304,600 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 483.72176426338785,600 500,600 500,700 483.72176426338785,700 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "15s",
    keyTimes: "0;0.5;1",
    values: "M 483.72176426338785,600 500,600 500,700 483.72176426338785,700 ; M 500,600 500,600 500,700 500,700 ; M 483.72176426338785,600 500,600 500,700 483.72176426338785,700 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 400,700 400,745.8847999920014 500,745.8847999920014 500,700 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 400,700 400,745.8847999920014 500,745.8847999920014 500,700 ; M 400,700 400,700 500,700 500,700 ; M 400,700 400,745.8847999920014 500,745.8847999920014 500,700 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 400,700 400,800 445.8847999920014,800 445.8847999920014,700 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 400,700 400,800 445.8847999920014,800 445.8847999920014,700 ; M 400,700 400,800 400,800 400,700 ; M 400,700 400,800 445.8847999920014,800 445.8847999920014,700 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 481.6460800031994,700 500,700 500,800 481.6460800031994,800 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 481.6460800031994,700 500,700 500,800 481.6460800031994,800 ; M 500,700 500,700 500,800 500,800 ; M 481.6460800031994,700 500,700 500,800 481.6460800031994,800 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 500,0 500,45.34153842793034 600,45.34153842793034 600,0 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "14s",
    keyTimes: "0;0.5;1",
    values: "M 500,0 500,45.34153842793034 600,45.34153842793034 600,0 ; M 500,0 500,0 600,0 600,0 ; M 500,0 500,45.34153842793034 600,45.34153842793034 600,0 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 500,0 500,100 545.3415384279303,100 545.3415384279303,0 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "14s",
    keyTimes: "0;0.5;1",
    values: "M 500,0 500,100 545.3415384279303,100 545.3415384279303,0 ; M 500,0 500,100 500,100 500,0 ; M 500,0 500,100 545.3415384279303,100 545.3415384279303,0 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 581.8633846288278,0 600,0 600,100 581.8633846288278,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "14s",
    keyTimes: "0;0.5;1",
    values: "M 581.8633846288278,0 600,0 600,100 581.8633846288278,100 ; M 600,0 600,0 600,100 600,100 ; M 581.8633846288278,0 600,0 600,100 581.8633846288278,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 500,100 500,126.03002577089894 600,126.03002577089894 600,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "6s",
    keyTimes: "0;0.5;1",
    values: "M 500,100 500,126.03002577089894 600,126.03002577089894 600,100 ; M 500,100 500,100 600,100 600,100 ; M 500,100 500,126.03002577089894 600,126.03002577089894 600,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 500,100 500,200 526.030025770899,200 526.030025770899,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "6s",
    keyTimes: "0;0.5;1",
    values: "M 500,100 500,200 526.030025770899,200 526.030025770899,100 ; M 500,100 500,200 500,200 500,100 ; M 500,100 500,200 526.030025770899,200 526.030025770899,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 589.5879896916405,100 600,100 600,200 589.5879896916405,200 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "6s",
    keyTimes: "0;0.5;1",
    values: "M 589.5879896916405,100 600,100 600,200 589.5879896916405,200 ; M 600,100 600,100 600,200 600,200 ; M 589.5879896916405,100 600,100 600,200 589.5879896916405,200 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 500,200 500,234.91372718610137 600,234.91372718610137 600,200 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "9s",
    keyTimes: "0;0.5;1",
    values: "M 500,200 500,234.91372718610137 600,234.91372718610137 600,200 ; M 500,200 500,200 600,200 600,200 ; M 500,200 500,234.91372718610137 600,234.91372718610137 600,200 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 500,200 500,300 534.9137271861014,300 534.9137271861014,200 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "9s",
    keyTimes: "0;0.5;1",
    values: "M 500,200 500,300 534.9137271861014,300 534.9137271861014,200 ; M 500,200 500,300 500,300 500,200 ; M 500,200 500,300 534.9137271861014,300 534.9137271861014,200 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 586.0345091255595,200 600,200 600,300 586.0345091255595,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "9s",
    keyTimes: "0;0.5;1",
    values: "M 586.0345091255595,200 600,200 600,300 586.0345091255595,300 ; M 600,200 600,200 600,300 600,300 ; M 586.0345091255595,200 600,200 600,300 586.0345091255595,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 500,300 500,327.32941388555554 600,327.32941388555554 600,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 500,300 500,327.32941388555554 600,327.32941388555554 600,300 ; M 500,300 500,300 600,300 600,300 ; M 500,300 500,327.32941388555554 600,327.32941388555554 600,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 500,300 500,400 527.3294138855555,400 527.3294138855555,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 500,300 500,400 527.3294138855555,400 527.3294138855555,300 ; M 500,300 500,400 500,400 500,300 ; M 500,300 500,400 527.3294138855555,400 527.3294138855555,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 589.0682344457778,300 600,300 600,400 589.0682344457778,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 589.0682344457778,300 600,300 600,400 589.0682344457778,400 ; M 600,300 600,300 600,400 600,400 ; M 589.0682344457778,300 600,300 600,400 589.0682344457778,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 500,400 500,434.31421834820065 600,434.31421834820065 600,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 500,400 500,434.31421834820065 600,434.31421834820065 600,400 ; M 500,400 500,400 600,400 600,400 ; M 500,400 500,434.31421834820065 600,434.31421834820065 600,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 500,400 500,500 534.3142183482007,500 534.3142183482007,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 500,400 500,500 534.3142183482007,500 534.3142183482007,400 ; M 500,400 500,500 500,500 500,400 ; M 500,400 500,500 534.3142183482007,500 534.3142183482007,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 586.2743126607197,400 600,400 600,500 586.2743126607197,500 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 586.2743126607197,400 600,400 600,500 586.2743126607197,500 ; M 600,400 600,400 600,500 600,500 ; M 586.2743126607197,400 600,400 600,500 586.2743126607197,500 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 500,500 500,526.6431469020215 600,526.6431469020215 600,500 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "6s",
    keyTimes: "0;0.5;1",
    values: "M 500,500 500,526.6431469020215 600,526.6431469020215 600,500 ; M 500,500 500,500 600,500 600,500 ; M 500,500 500,526.6431469020215 600,526.6431469020215 600,500 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 500,500 500,600 526.6431469020215,600 526.6431469020215,500 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "6s",
    keyTimes: "0;0.5;1",
    values: "M 500,500 500,600 526.6431469020215,600 526.6431469020215,500 ; M 500,500 500,600 500,600 500,500 ; M 500,500 500,600 526.6431469020215,600 526.6431469020215,500 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 589.3427412391914,500 600,500 600,600 589.3427412391914,600 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "6s",
    keyTimes: "0;0.5;1",
    values: "M 589.3427412391914,500 600,500 600,600 589.3427412391914,600 ; M 600,500 600,500 600,600 600,600 ; M 589.3427412391914,500 600,500 600,600 589.3427412391914,600 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 500,600 500,643.0404502370247 600,643.0404502370247 600,600 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "7s",
    keyTimes: "0;0.5;1",
    values: "M 500,600 500,643.0404502370247 600,643.0404502370247 600,600 ; M 500,600 500,600 600,600 600,600 ; M 500,600 500,643.0404502370247 600,643.0404502370247 600,600 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 500,600 500,700 543.0404502370247,700 543.0404502370247,600 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "7s",
    keyTimes: "0;0.5;1",
    values: "M 500,600 500,700 543.0404502370247,700 543.0404502370247,600 ; M 500,600 500,700 500,700 500,600 ; M 500,600 500,700 543.0404502370247,700 543.0404502370247,600 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 582.7838199051901,600 600,600 600,700 582.7838199051901,700 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "7s",
    keyTimes: "0;0.5;1",
    values: "M 582.7838199051901,600 600,600 600,700 582.7838199051901,700 ; M 600,600 600,600 600,700 600,700 ; M 582.7838199051901,600 600,600 600,700 582.7838199051901,700 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 500,700 500,736.2673723555838 600,736.2673723555838 600,700 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 500,700 500,736.2673723555838 600,736.2673723555838 600,700 ; M 500,700 500,700 600,700 600,700 ; M 500,700 500,736.2673723555838 600,736.2673723555838 600,700 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 500,700 500,800 536.2673723555838,800 536.2673723555838,700 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 500,700 500,800 536.2673723555838,800 536.2673723555838,700 ; M 500,700 500,800 500,800 500,700 ; M 500,700 500,800 536.2673723555838,800 536.2673723555838,700 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 585.4930510577665,700 600,700 600,800 585.4930510577665,800 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 585.4930510577665,700 600,700 600,800 585.4930510577665,800 ; M 600,700 600,700 600,800 600,800 ; M 585.4930510577665,700 600,700 600,800 585.4930510577665,800 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 600,0 600,37.79761789767829 700,37.79761789767829 700,0 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "12s",
    keyTimes: "0;0.5;1",
    values: "M 600,0 600,37.79761789767829 700,37.79761789767829 700,0 ; M 600,0 600,0 700,0 700,0 ; M 600,0 600,37.79761789767829 700,37.79761789767829 700,0 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 600,0 600,100 637.7976178976783,100 637.7976178976783,0 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "12s",
    keyTimes: "0;0.5;1",
    values: "M 600,0 600,100 637.7976178976783,100 637.7976178976783,0 ; M 600,0 600,100 600,100 600,0 ; M 600,0 600,100 637.7976178976783,100 637.7976178976783,0 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 684.8809528409287,0 700,0 700,100 684.8809528409287,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "12s",
    keyTimes: "0;0.5;1",
    values: "M 684.8809528409287,0 700,0 700,100 684.8809528409287,100 ; M 700,0 700,0 700,100 700,100 ; M 684.8809528409287,0 700,0 700,100 684.8809528409287,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 600,100 600,125.26137881979281 700,125.26137881979281 700,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "5s",
    keyTimes: "0;0.5;1",
    values: "M 600,100 600,125.26137881979281 700,125.26137881979281 700,100 ; M 600,100 600,100 700,100 700,100 ; M 600,100 600,125.26137881979281 700,125.26137881979281 700,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 600,100 600,200 625.2613788197928,200 625.2613788197928,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "5s",
    keyTimes: "0;0.5;1",
    values: "M 600,100 600,200 625.2613788197928,200 625.2613788197928,100 ; M 600,100 600,200 600,200 600,100 ; M 600,100 600,200 625.2613788197928,200 625.2613788197928,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 689.8954484720829,100 700,100 700,200 689.8954484720829,200 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "5s",
    keyTimes: "0;0.5;1",
    values: "M 689.8954484720829,100 700,100 700,200 689.8954484720829,200 ; M 700,100 700,100 700,200 700,200 ; M 689.8954484720829,100 700,100 700,200 689.8954484720829,200 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 600,200 600,229.9123249540432 700,229.9123249540432 700,200 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 600,200 600,229.9123249540432 700,229.9123249540432 700,200 ; M 600,200 600,200 700,200 700,200 ; M 600,200 600,229.9123249540432 700,229.9123249540432 700,200 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 600,200 600,300 629.9123249540432,300 629.9123249540432,200 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 600,200 600,300 629.9123249540432,300 629.9123249540432,200 ; M 600,200 600,300 600,300 600,200 ; M 600,200 600,300 629.9123249540432,300 629.9123249540432,200 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 688.0350700183827,200 700,200 700,300 688.0350700183827,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 688.0350700183827,200 700,200 700,300 688.0350700183827,300 ; M 700,200 700,200 700,300 700,300 ; M 688.0350700183827,200 700,200 700,300 688.0350700183827,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 600,300 600,348.6196250858894 700,348.6196250858894 700,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "7s",
    keyTimes: "0;0.5;1",
    values: "M 600,300 600,348.6196250858894 700,348.6196250858894 700,300 ; M 600,300 600,300 700,300 700,300 ; M 600,300 600,348.6196250858894 700,348.6196250858894 700,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 600,300 600,400 648.6196250858894,400 648.6196250858894,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "7s",
    keyTimes: "0;0.5;1",
    values: "M 600,300 600,400 648.6196250858894,400 648.6196250858894,300 ; M 600,300 600,400 600,400 600,300 ; M 600,300 600,400 648.6196250858894,400 648.6196250858894,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 680.5521499656443,300 700,300 700,400 680.5521499656443,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "7s",
    keyTimes: "0;0.5;1",
    values: "M 680.5521499656443,300 700,300 700,400 680.5521499656443,400 ; M 700,300 700,300 700,400 700,400 ; M 680.5521499656443,300 700,300 700,400 680.5521499656443,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 600,400 600,443.09605071411573 700,443.09605071411573 700,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 600,400 600,443.09605071411573 700,443.09605071411573 700,400 ; M 600,400 600,400 700,400 700,400 ; M 600,400 600,443.09605071411573 700,443.09605071411573 700,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 600,400 600,500 643.0960507141158,500 643.0960507141158,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 600,400 600,500 643.0960507141158,500 643.0960507141158,400 ; M 600,400 600,500 600,500 600,400 ; M 600,400 600,500 643.0960507141158,500 643.0960507141158,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 682.7615797143537,400 700,400 700,500 682.7615797143537,500 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 682.7615797143537,400 700,400 700,500 682.7615797143537,500 ; M 700,400 700,400 700,500 700,500 ; M 682.7615797143537,400 700,400 700,500 682.7615797143537,500 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 600,500 600,542.7165367103688 700,542.7165367103688 700,500 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "9s",
    keyTimes: "0;0.5;1",
    values: "M 600,500 600,542.7165367103688 700,542.7165367103688 700,500 ; M 600,500 600,500 700,500 700,500 ; M 600,500 600,542.7165367103688 700,542.7165367103688 700,500 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 600,500 600,600 642.7165367103688,600 642.7165367103688,500 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "9s",
    keyTimes: "0;0.5;1",
    values: "M 600,500 600,600 642.7165367103688,600 642.7165367103688,500 ; M 600,500 600,600 600,600 600,500 ; M 600,500 600,600 642.7165367103688,600 642.7165367103688,500 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 682.9133853158525,500 700,500 700,600 682.9133853158525,600 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "9s",
    keyTimes: "0;0.5;1",
    values: "M 682.9133853158525,500 700,500 700,600 682.9133853158525,600 ; M 700,500 700,500 700,600 700,600 ; M 682.9133853158525,500 700,500 700,600 682.9133853158525,600 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 600,600 600,641.8611635795479 700,641.8611635795479 700,600 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "7s",
    keyTimes: "0;0.5;1",
    values: "M 600,600 600,641.8611635795479 700,641.8611635795479 700,600 ; M 600,600 600,600 700,600 700,600 ; M 600,600 600,641.8611635795479 700,641.8611635795479 700,600 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 600,600 600,700 641.8611635795479,700 641.8611635795479,600 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "7s",
    keyTimes: "0;0.5;1",
    values: "M 600,600 600,700 641.8611635795479,700 641.8611635795479,600 ; M 600,600 600,700 600,700 600,600 ; M 600,600 600,700 641.8611635795479,700 641.8611635795479,600 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 683.2555345681808,600 700,600 700,700 683.2555345681808,700 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "7s",
    keyTimes: "0;0.5;1",
    values: "M 683.2555345681808,600 700,600 700,700 683.2555345681808,700 ; M 700,600 700,600 700,700 700,700 ; M 683.2555345681808,600 700,600 700,700 683.2555345681808,700 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 600,700 600,725.989335236938 700,725.989335236938 700,700 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 600,700 600,725.989335236938 700,725.989335236938 700,700 ; M 600,700 600,700 700,700 700,700 ; M 600,700 600,725.989335236938 700,725.989335236938 700,700 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 600,700 600,800 625.989335236938,800 625.989335236938,700 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 600,700 600,800 625.989335236938,800 625.989335236938,700 ; M 600,700 600,800 600,800 600,700 ; M 600,700 600,800 625.989335236938,800 625.989335236938,700 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 689.6042659052248,700 700,700 700,800 689.6042659052248,800 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 689.6042659052248,700 700,700 700,800 689.6042659052248,800 ; M 700,700 700,700 700,800 700,800 ; M 689.6042659052248,700 700,700 700,800 689.6042659052248,800 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 700,0 700,32.977030347910116 800,32.977030347910116 800,0 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "5s",
    keyTimes: "0;0.5;1",
    values: "M 700,0 700,32.977030347910116 800,32.977030347910116 800,0 ; M 700,0 700,0 800,0 800,0 ; M 700,0 700,32.977030347910116 800,32.977030347910116 800,0 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 700,0 700,100 732.9770303479102,100 732.9770303479102,0 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "5s",
    keyTimes: "0;0.5;1",
    values: "M 700,0 700,100 732.9770303479102,100 732.9770303479102,0 ; M 700,0 700,100 700,100 700,0 ; M 700,0 700,100 732.9770303479102,100 732.9770303479102,0 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 786.809187860836,0 800,0 800,100 786.809187860836,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "5s",
    keyTimes: "0;0.5;1",
    values: "M 786.809187860836,0 800,0 800,100 786.809187860836,100 ; M 800,0 800,0 800,100 800,100 ; M 786.809187860836,0 800,0 800,100 786.809187860836,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 700,100 700,135.44763640436597 800,135.44763640436597 800,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "9s",
    keyTimes: "0;0.5;1",
    values: "M 700,100 700,135.44763640436597 800,135.44763640436597 800,100 ; M 700,100 700,100 800,100 800,100 ; M 700,100 700,135.44763640436597 800,135.44763640436597 800,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 700,100 700,200 735.447636404366,200 735.447636404366,100 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "9s",
    keyTimes: "0;0.5;1",
    values: "M 700,100 700,200 735.447636404366,200 735.447636404366,100 ; M 700,100 700,200 700,200 700,100 ; M 700,100 700,200 735.447636404366,200 735.447636404366,100 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 785.8209454382536,100 800,100 800,200 785.8209454382536,200 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "9s",
    keyTimes: "0;0.5;1",
    values: "M 785.8209454382536,100 800,100 800,200 785.8209454382536,200 ; M 800,100 800,100 800,200 800,200 ; M 785.8209454382536,100 800,100 800,200 785.8209454382536,200 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 700,200 700,249.08260203639583 800,249.08260203639583 800,200 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 700,200 700,249.08260203639583 800,249.08260203639583 800,200 ; M 700,200 700,200 800,200 800,200 ; M 700,200 700,249.08260203639583 800,249.08260203639583 800,200 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 700,200 700,300 749.0826020363959,300 749.0826020363959,200 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 700,200 700,300 749.0826020363959,300 749.0826020363959,200 ; M 700,200 700,300 700,300 700,200 ; M 700,200 700,300 749.0826020363959,300 749.0826020363959,200 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 780.3669591854417,200 800,200 800,300 780.3669591854417,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 780.3669591854417,200 800,200 800,300 780.3669591854417,300 ; M 800,200 800,200 800,300 800,300 ; M 780.3669591854417,200 800,200 800,300 780.3669591854417,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 700,300 700,334.82405103033346 800,334.82405103033346 800,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 700,300 700,334.82405103033346 800,334.82405103033346 800,300 ; M 700,300 700,300 800,300 800,300 ; M 700,300 700,334.82405103033346 800,334.82405103033346 800,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 700,300 700,400 734.8240510303335,400 734.8240510303335,300 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 700,300 700,400 734.8240510303335,400 734.8240510303335,300 ; M 700,300 700,400 700,400 700,300 ; M 700,300 700,400 734.8240510303335,400 734.8240510303335,300 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 786.0703795878666,300 800,300 800,400 786.0703795878666,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 786.0703795878666,300 800,300 800,400 786.0703795878666,400 ; M 800,300 800,300 800,400 800,400 ; M 786.0703795878666,300 800,300 800,400 786.0703795878666,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 700,400 700,445.71010196443996 800,445.71010196443996 800,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 700,400 700,445.71010196443996 800,445.71010196443996 800,400 ; M 700,400 700,400 800,400 800,400 ; M 700,400 700,445.71010196443996 800,445.71010196443996 800,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 700,400 700,500 745.7101019644399,500 745.7101019644399,400 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 700,400 700,500 745.7101019644399,500 745.7101019644399,400 ; M 700,400 700,500 700,500 700,400 ; M 700,400 700,500 745.7101019644399,500 745.7101019644399,400 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 781.715959214224,400 800,400 800,500 781.715959214224,500 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "11s",
    keyTimes: "0;0.5;1",
    values: "M 781.715959214224,400 800,400 800,500 781.715959214224,500 ; M 800,400 800,400 800,500 800,500 ; M 781.715959214224,400 800,400 800,500 781.715959214224,500 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 700,500 700,544.154563808121 800,544.154563808121 800,500 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "14s",
    keyTimes: "0;0.5;1",
    values: "M 700,500 700,544.154563808121 800,544.154563808121 800,500 ; M 700,500 700,500 800,500 800,500 ; M 700,500 700,544.154563808121 800,544.154563808121 800,500 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 700,500 700,600 744.154563808121,600 744.154563808121,500 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "14s",
    keyTimes: "0;0.5;1",
    values: "M 700,500 700,600 744.154563808121,600 744.154563808121,500 ; M 700,500 700,600 700,600 700,500 ; M 700,500 700,600 744.154563808121,600 744.154563808121,500 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 782.3381744767516,500 800,500 800,600 782.3381744767516,600 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "14s",
    keyTimes: "0;0.5;1",
    values: "M 782.3381744767516,500 800,500 800,600 782.3381744767516,600 ; M 800,500 800,500 800,600 800,600 ; M 782.3381744767516,500 800,500 800,600 782.3381744767516,600 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 700,600 700,625.4890545663357 800,625.4890545663357 800,600 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 700,600 700,625.4890545663357 800,625.4890545663357 800,600 ; M 700,600 700,600 800,600 800,600 ; M 700,600 700,625.4890545663357 800,625.4890545663357 800,600 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 700,600 700,700 725.4890545663357,700 725.4890545663357,600 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 700,600 700,700 725.4890545663357,700 725.4890545663357,600 ; M 700,600 700,700 700,700 700,600 ; M 700,600 700,700 725.4890545663357,700 725.4890545663357,600 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 789.8043781734658,600 800,600 800,700 789.8043781734658,700 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "13s",
    keyTimes: "0;0.5;1",
    values: "M 789.8043781734658,600 800,600 800,700 789.8043781734658,700 ; M 800,600 800,600 800,700 800,700 ; M 789.8043781734658,600 800,600 800,700 789.8043781734658,700 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 700,700 700,745.3556016158312 800,745.3556016158312 800,700 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "8s",
    keyTimes: "0;0.5;1",
    values: "M 700,700 700,745.3556016158312 800,745.3556016158312 800,700 ; M 700,700 700,700 800,700 800,700 ; M 700,700 700,745.3556016158312 800,745.3556016158312 800,700 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 700,700 700,800 745.3556016158312,800 745.3556016158312,700 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "8s",
    keyTimes: "0;0.5;1",
    values: "M 700,700 700,800 745.3556016158312,800 745.3556016158312,700 ; M 700,700 700,800 700,800 700,700 ; M 700,700 700,800 745.3556016158312,800 745.3556016158312,700 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M 781.8577593536675,700 800,700 800,800 781.8577593536675,800 "
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    repeatDur: "indefinite",
    dur: "8s",
    keyTimes: "0;0.5;1",
    values: "M 781.8577593536675,700 800,700 800,800 781.8577593536675,800 ; M 800,700 800,700 800,800 800,800 ; M 781.8577593536675,700 800,700 800,800 781.8577593536675,800 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgBgP6E);
export default __webpack_public_path__ + "static/media/svg_bg_p6e.57f8d7dad25693cfeb560d5ec79e5554.svg";
export { ForwardRef as ReactComponent };